<template>
  <div>
    <PageHeader title="Sport Clubs"></PageHeader>
    <v-card
      outlined
      class="vcardcontent"
       v-bind:class="{ 'version-spacing': !isLoggedIn }"
    >
      <v-card-text style="color:#ffffff;" class="honeyBold">
        <p>
          <b>Generate Club income for free</b>
        </p>
        <p>
          3 Easy Steps
        </p>
        <ol>
          <li>Choose an upcoming team match (3 – 5 days prior to match start)</li>
          <li>Obtain an initial cash prize from club sponsor</li>
          <li>Contact Fanhive at support@fanhive.co.uk</li>
        </ol>
      </v-card-text>
    </v-card>
    <v-container pa-0>
      <v-row class="">
        <v-col class="text-center">
          <h4 class="mb-0">
            For the Club
          </h4>
          <hr class="mt-1 hr-home">
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center">
          <p>Team Sport Clubs may encourage their Fans to support the club by entering their Player of the Match prize competitions through social media and announcements</p>
          <p>The initial sponsored cash prize and half the money raised is paid out in Fan prize money</p>
          <p>Fanhive manages competition sport related entry questions, online payments, notifications to entrants, the prize draw and payments to the club and winners</p>
        </v-col>
      </v-row>
    </v-container>
    <v-card
      outlined
      class="vcardcontent mt-6"
    >
      <v-card-text style="color:#ffffff;" class="honeyBold">
        <v-container>
          <v-row>
            <v-col class="text-center">
              <h4 class="mb-0">
                Club Income Calculator per Competition
              </h4>
              <hr class="mt-1 hr-home">
            </v-col>
          </v-row>
          <v-row class="mt-12">
            <v-col class="pa-0">
              <v-text-field
                v-model="numberOfFans"
                :rules="[rules.required]"
                label="Estimated number of fans"
                outlined
                required
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pa-0">
              <v-text-field
                v-model="entryPrice"
                :rules="[rules.required]"
                label="Entry Price (£)"
                outlined
                required
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pa-0">
              <v-btn
                block
                solid
                large
                style="color: #ffffff !important;border: 1px solid #ffb300;"
                color="fanhiveHoney"
                class=""
                type="submit"
                id="click-calculate"
                @click="calculate"
              >
                Calculate
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="mt-8">
            <v-col class="text-center">
              <h2>£{{incomePotential}}</h2>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <v-container>
      <v-row class="mt-3">
        <v-col class="text-center">
          <h4 class="mb-0">
            For The Sponsors
          </h4>
          <hr class="mt-1 hr-home">
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center">
          <p>Sponsors may wish to sponsor the initial cash prize amount to elevate public engagement and brand awareness</p>
          <p>The Sponsor logo will be associated with the respective competitions and the Winners</p>
        </v-col>
      </v-row>
      <v-row class="mt-8">
        <v-col>
          <hr style="border-top:1px;border-color:#474747;">
        </v-col>
      </v-row>
      <v-row class="mt-3">
        <v-col class="text-center">
          <h4 class="mb-0">
            For The Players
          </h4>
          <hr class="mt-1 hr-home">
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center">
          <p>The Players in the respective matches appreciate the acknowledgement of their performance by the Fans</p>
          <p>They stand a chance of being voted as the Player of the Match</p>
          <p>Player ratings by the Fans are listed by Fanhive where they may be viewed by Managers, Coaches, Family, Friends, and the Fans</p>
        </v-col>
      </v-row>
      <v-row class="mt-8">
        <v-col>
          <hr style="border-top:1px;border-color:#474747;">
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';

export default {
  name: 'sportclubs',
  data: () => ({
    numberOfFans: 1000,
    entryPrice: 2,
    incomePotential: 0,
    rules: {
      required: value => !!value || 'Required.'
    }
  }),
  components: {
    PageHeader
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn;
    },
  },
  methods: {
    calculate: function () {

      if(this.numberOfFans > 0 && this.entryPrice > 0){
        var entryPence = this.entryPrice*100
        console.log(entryPence)
        var bankComm = entryPence * 0.02
        console.log(bankComm)
        var bankCharge = bankComm+23
        console.log(bankCharge)
        var z = entryPence - bankCharge
        console.log(z)
        this.incomePotential = ((this.numberOfFans * z)/100)*0.4
        console.log(this.incomePotential)
      } else {
        console.log('Values are invalid')
        console.log(this.numberOfFans)
        console.log(this.ent)
      }
    }
  },
  created () {
    this.calculate()
  }
}
</script>